import { MediaGrid } from 'ui/components/2-molecules/MediaGrid/MediaGrid';

export const MediaGridFeature: React.FC<Content.MediaGrid> = ({ content }) => {
	const itemsTransformed = content?.properties.items.map((item) => {
		const { video, image, showVideoControls } = item.content?.properties;

		if (item.content.documentType === 'mediaGridVideo') {
			return {
				video: {
					url: video?.url,
					poster: video?.poster,
					autoplay: item.settings?.properties?.autoplay || false,
					showControls: showVideoControls,
				},
				image: {
					url: image?.url,
					altText: image?.properties?.altText,
				},
			};
		}

		return (
			item.content.documentType === 'mediaGridImage' && {
				image: {
					url: image?.url,
					altText: image?.properties?.altText,
				},
			}
		);
	});

	return <MediaGrid items={itemsTransformed} bgColor={content?.properties?.color} />;
};
